import React from 'react';
import RenderPasajebusInputs from '../RenderPasajebusInputs/RenderPasajebusInputs';
function RenderInputs({
  t,
  KuposSelectBox,
  select1,
  select2,
  setSelect1,
  setSelect2,
  sourcePlaceholder,
  selectOptions,
  selectSourceCity,
  onSourceChange,
  onInputChange,
  sourceCityError,
  getOriginSelectedFilteredDestinations,
  selectOptions2,
  selectDestinationCity,
  onDestinationChange,
  onInputChange2,
  destinationPlaceholder,
  destinationCityError,
  onwardDate,
  onwardDateChange,
  dateError,
  returnDate,
  returnDateChange,
  dateErrorReturn,
  search,
  destinationRef
}) {
  return (
    <RenderPasajebusInputs
      t={t}
      KuposSelectBox={KuposSelectBox}
      select1={select1}
      setSelect1={setSelect1}
      selectOptions={selectOptions}
      selectSourceCity={selectSourceCity}
      onSourceChange={onSourceChange}
      onInputChange={onInputChange}
      select2={select2}
      setSelect2={setSelect2}
      sourcePlaceholder={sourcePlaceholder}
      sourceCityError={sourceCityError}
      selectOptions2={selectOptions2}
      selectDestinationCity={selectDestinationCity}
      getOriginSelectedFilteredDestinations={getOriginSelectedFilteredDestinations}
      onDestinationChange={onDestinationChange}
      onInputChange2={onInputChange2}
      destinationPlaceholder={destinationPlaceholder}
      destinationCityError={destinationCityError}
      onwardDate={onwardDate}
      onwardDateChange={onwardDateChange}
      dateError={dateError}
      returnDate={returnDate}
      returnDateChange={returnDateChange}
      dateErrorReturn={dateErrorReturn}
      search={search}
      destinationRef={destinationRef}
    />
  );
}

export default RenderInputs;



// WEBPACK FOOTER //
// ./src/features/home/HomeSearchBoxPB/RenderInputs/RenderInputs.js